import { Injectable } from '@angular/core';

/**
 * Fonte: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */

@Injectable({
    providedIn: 'root'
})
export class GuidService {
    private s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
    }

    /** Gera um Guid */
    generate() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
        this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }
}
